export const SHARE_KEY_HEADER_NAME = 'X-Share-Key';

/** Read-only views of a collection or timeline shared through an access key live under this prefix. */
export const SHARED_VIEW_ROUTE_PREFIX = '/shared/:shareKey';

export const sharedViewPath = (shareKey: string, path: string) => `/shared/${shareKey}${path}`;

/** Fields every share key record has, whichever resource it shares. */
export type AccessKeyRecord = {
	id: string;
	secretKey: string;
	expiresAt: string | null;
	createdAt: string;
};
